"use strict";
/*!
 * Copyright (C) 2019, NewFoundry, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;
exports.diffConfigurations = void 0;

var lodash_1 = __importDefault(require("lodash"));

var diffConfigurations = function diffConfigurations(before, after) {
  var diff = {};
  before = lodash_1["default"].omitBy(before, lodash_1["default"].isNil);
  after = lodash_1["default"].omitBy(after, lodash_1["default"].isNil);
  var additions = lodash_1["default"].difference(lodash_1["default"].keys(after), lodash_1["default"].keys(before));
  var subtractions = lodash_1["default"].difference(lodash_1["default"].keys(before), lodash_1["default"].keys(after));
  additions.forEach(function (a) {
    return diff["+" + a] = "+" + after[a];
  });
  subtractions.forEach(function (s) {
    return diff["-" + s] = "-" + before[s];
  });
  var additionsVal = lodash_1["default"].difference(lodash_1["default"].values(after), lodash_1["default"].values(before));
  var subtractionsVal = lodash_1["default"].difference(lodash_1["default"].values(before), lodash_1["default"].values(after));
  additionsVal.forEach(function (a) {
    var invertedAfter = lodash_1["default"].invert(after);

    if (!lodash_1["default"].includes(additions, invertedAfter[a])) {
      diff[invertedAfter[a]] = "+" + a;
    }
  });
  subtractionsVal.forEach(function (s) {
    var invertedBefore = lodash_1["default"].invert(before);

    if (!lodash_1["default"].includes(additions, invertedBefore[s])) {
      if (diff[invertedBefore[s]]) {
        var current = diff[invertedBefore[s]];

        if (current) {
          diff[invertedBefore[s]] = ["-" + s, current];
        }

        return;
      }

      diff[invertedBefore[s]] = "-" + s;
    }
  });
  return diff;
};

exports.diffConfigurations = diffConfigurations;